import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import type { CreateRoomBookingDTO } from "../../domain/contracts/room-bookings";
import { useCreateRoomBooking } from "../api/queries";
import { buildRoomBookingSuccessSearch } from "../lib/room-booking-success-search";
import { RoomBookingForm } from "../ui/RoomBookingForm";

export function RoomBookingCreatePage() {
  const nav = useNavigate({ from: "/app/room-bookings/new" });
  const createBooking = useCreateRoomBooking();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ການຈອງຫ້ອງ", to: "/app/room-bookings" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງການຈອງຫ້ອງ
            </h2>
            <p className="text-muted-foreground">ຈອງຫ້ອງໃໝ່ — ເລືອກຄິດເງິນຫຼືບໍ່ກໍ່ໄດ້</p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => nav({ to: "/app/room-bookings/bulk-create" })}
            >
              ຈອງຫຼາຍຄັ້ງ
            </Button>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/room-bookings" })}
            >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
          </div>
        </div>

        <div className="mt-6">
          <RoomBookingForm
            mode="create"
            onSubmit={async (vals) => {
              try {
                const payload = vals as CreateRoomBookingDTO;
                const result = await createBooking.mutateAsync(payload);
                const successSearch = buildRoomBookingSuccessSearch(
                  result.id,
                  result,
                );
                if (successSearch) {
                  nav({
                    to: "/app/room-bookings/success",
                    search: successSearch,
                  });
                } else {
                  nav({
                    to: "/app/room-bookings/$id",
                    params: { id: result.id },
                  });
                }
              } catch {
                // Error handled by mutation
              }
            }}
            submitting={createBooking.isPending}
          />
        </div>
      </Main>
    </>
  );
}
